import { ModulesMap } from '@/config/data/modulesMaps'

import DataTransferModule from '@/services/dataTransferModule'

import FieldsApi from '@/services/apiServiceModules/fieldsApi'
const fieldsApi = new FieldsApi()

export default class FieldsDt extends DataTransferModule {
	constructor() {
		super(ModulesMap.FIELDS, fieldsApi, {
			useCache: true,
		})
	}
}
